import { render, staticRenderFns } from "./WorkPackItemsContainer.vue?vue&type=template&id=78b39abe&"
import script from "./WorkPackItemsContainer.vue?vue&type=script&lang=js&"
export * from "./WorkPackItemsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b39abe')) {
      api.createRecord('78b39abe', component.options)
    } else {
      api.reload('78b39abe', component.options)
    }
    module.hot.accept("./WorkPackItemsContainer.vue?vue&type=template&id=78b39abe&", function () {
      api.rerender('78b39abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/WorkPackItemsContainer.vue"
export default component.exports